<template>
  <div>
    <section class="section">
      <div class="container">
        <h2 class="title">
          Features
        </h2>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Demo</th>
              <th>BeatCaps</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th>
                <span class="icon">
                  <i class="fas fa-drum" />
                </span>Generate caption files using BPM + offset
              </th>
              <th>
                <i class="fas fa-check" />
              </th>
              <th>
                <i class="fas fa-check" />
              </th>
            </tr>
            <tr>
              <th>
                <span class="icon">
                  <i class="fas fa-file-audio" />
                </span>Generate caption files from rhythm metadata file
              </th>
              <th>
                <i class="fas fa-check" />
              </th>
              <th>
                <i class="fas fa-check" />
              </th>
            </tr>
            <tr>
              <th>
                <span class="icon">
                  <i class="fas fa-digital-tachograph" />
                </span>View captions playing on video
              </th>
              <th>
                <i class="fas fa-check" />
              </th>
              <th>
                <i class="fas fa-check" />
              </th>
            </tr>
            <tr>
              <th>
                <span class="icon">
                  <i class="fab fa-searchengin" />
                </span>Analyze rhythm of music and video files
              </th>
              <th />
              <th>
                <i class="fas fa-check" />
              </th>
            </tr>
            <tr>
              <th>
                <span class="icon">
                  <i class="fas fa-link" />
                </span>Integrate with video processing workflows
              </th>
              <th />
              <th>
                <i class="fas fa-check" />
              </th>
            </tr>
            <tr>
              <th>
                <span class="icon">
                  <i class="fas fa-hand-holding-usd" />
                </span>Help find grants to subsidize costs
              </th>
              <th />
              <th>
                <i class="fas fa-check" />
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
    <section class="section">
      <article class="container">
        <h2 class="title">
          Demo
        </h2>
        <!-- <span>
        <awsui-button
          :disabled="!captionInput || captionInput === caption.trim() || error.length > 0 || false"
          text="Cancel"
          @click="reset"
        />
        <awsui-button
          :disabled="!captionInput || captionInput === caption.trim() || error.length > 0 || false"
          text="Save"
          variant="primary"
          @click="save"
        />
        </span>-->
        <form @submit.prevent="setUrl">
          <label class="label">
            <span>Text Displayed</span>
            <input
              class="control"
              name="text"
              type="text"
              placeholder="███ ███ ███"
              :value="text"
            >
          </label>
          <label class="label">
            <span>Video URL</span>
            <input
              class="control"
              name="url"
              type="url"
              :value="mediaUrl"
            >
          </label>
          <div class="control">
            <input
              type="submit"
              value="Submit"
            >
          </div>
        </form>
        <!-- :disabled="error.length > 0 || false" -->
        <caption-editor
          v-model="captionInput"
          :text="text"
          @error="showError"
        />
        <div class="field">
          <label class="label">Caption URL</label>
          <a
            class="control"
            :href="blobUrl"
          >{{ blobUrl }}</a>
        </div>
        <div class="columns">
          <div class="column">
            <h3 class="subtitle">
              Original Video
            </h3>
            <video
              controls
              loop
            >
              <source
                :src="mediaUrl"
                type="video/mp4"
              >
            </video>
          </div>
          <div class="column">
            <h3 class="subtitle">
              Video with BeatCaps
            </h3>
            <video
              controls
              loop
            >
              <source
                :src="mediaUrl"
                type="video/mp4"
              >
              <track
                default
                kind="captions"
                :src="blobUrl"
                srclang="en"
                label="BeatCaps"
              >
            </video>
            <!-- <video-player
          :output="mediaUrl"
          :player="players[0]"
          :track="blobUrl"
          :type="type"
          class="task-box"
          style="min-height: 300px"
          @error="showError"
          @remove="playerRemove"
          @set="playerSet"
            />-->
          </div>
        </div>
      </article>
    </section>
    <section class="section">
      <div class="container">
        <h2 class="title has-text-centered">
          Pricing
        </h2>
      </div>

      <div class="container box">
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="subtitle">
                Creator
              </p>
              <p class="heading">
                Use our hosted cloud service
              </p>
              <p class="title">
                Coming Soon
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="subtitle">
                Enterprise
              </p>
              <p class="heading">
                We build it into your cloud
              </p>
              <a
                class="title"
                href="mailto:info@beatcaps.io"
              >Contact Us</a>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="subtitle">
                License
              </p>
              <p class="heading">
                License our patent
              </p>
              <a
                class="title"
                href="mailto:info@beatcaps.io"
              >Contact Us</a>
            </div>
          </div>
        </nav>
      </div>
    </section>
  </div>
</template>

<script>
// import AwsuiButton from "../components/AwsuiButton.vue";
// import AwsuiFormField from '../components/AwsuiFormField.vue';
// import AwsuiFormSection from '../components/AwsuiFormSection.vue';
import CaptionEditor from '../components/CaptionEditor.vue'
// import LoadingSquare from '../components/LoadingSquare.vue';
// import VideoPlayer from "../components/VideoPlayer.vue";

export default {
  name: 'CaptionView',
  components: {
    // AwsuiButton,
    CaptionEditor
    // LoadingSquare,
    // VideoPlayer,
  },
  props: {},
  data () {
    return {
      blobUrl: '',
      caption: '',
      captionInput: '',
      error: '',
      mediaBlob: '',
      mediaUrl:
        'https://archive.org/serve/youtube-sesOnXMcaBk/Linkin_Park_-_Faint-sesOnXMcaBk.mp4',
      path: '',
      players: {},
      text: '███ ███ ███',
      type: 'video/mp4'
    }
    // • █
  },
  computed: {},
  watch: {
    caption (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$logger.debug('caption-view', newVal)
        this.captionInput = newVal
      }
    },
    captionInput (newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.blobUrl = this.blobBuilder(newVal)
      }
    }
  },
  created () {
    this.$emit('theme', 'light')
  },
  methods: {
    /**
     * Store WebVTT text as blob URL
     */
    blobBuilder (content) {
      const blob = new Blob([content], {
        type: 'text/vtt;charset=UTF-8'
      })
      const url = URL.createObjectURL(blob)
      return url

      /*
        if ('Blob' in window && 'URL' in window && 'createObjectURL' in URL) {
          if (blob && 'revokeBlobURL' in URL) {
            URL.revokeBlobURL(blobURL);
          }
          blob = new Blob([vtt.value], {type:'text/vtt'});
          blobURL = URL.createObjectURL(blob);
          track.src = blobURL;
        } else {
          track.src = 'data:text/vtt;base64,' + btoa(vtt.value);
        }
        if (videoElm.lastChild instanceof HTMLTrackElement) {
          videoElm.removeChild(videoElm.lastChild);
        }
        videoElm.appendChild(track);
        track.track.mode = 'showing';
        if (videoElm.paused) {
          videoElm.currentTime = videoElm.currentTime;
        }
      }
       */
    },
    filterForms (target) {
      const formData = new FormData(target).entries()

      const filtered = {}

      for (const pair of formData) {
        // filtered[pair[0]] = pair[1].trim()
        if (typeof filtered[pair[0]] === 'undefined') {
          filtered[pair[0]] = pair[1].trim()
        } else if (Array.isArray(filtered[pair[0]])) {
          filtered[pair[0]].push(pair[1].trim())
        } else {
          const temp = []
          temp.push(filtered[pair[0]])
          temp.push(pair[1].trim())
          filtered[pair[0]] = temp
        }
      }
      return filtered
    },
    filterWebVTT (paths) {
      for (let i = 0, len = paths.length; i < len; i += 1) {
        if (paths[i].split('.').pop() === 'vtt') {
          return paths[i]
        }
      }
      return false
    },
    // parseWebVTT (outputs) {
    //   try {
    //     const parsed = this.parseS3(outputs);
    //     this.mediaUrl = parsed[0];
    //     const filtered = this.filterWebVTT(parsed);
    //     if (filtered) {
    //       return filtered;
    //     }
    //     throw new Error('No WebVTT files found');
    //   } catch (err) {
    //     this.showError(err);
    //     throw err;
    //   }
    // },
    reset () {
      this.captionInput = this.caption
    },
    save (event) {
      this.caption = this.captionInput
      this.$logger.debug('caption-view', event)
    },
    setMediaBlob (value) {
      if (this.mediaBlob.search('blob:') >= 0) {
        URL.revokeObjectURL(this.mediaBlob)
      }
      this.mediaBlob = value
    },
    playerRemove () {
      delete this.players[0]
      // this.players = this.players
    },
    playerSet (evt) {
      this.$set(this.players, 0, evt.data)
    },
    setUrl (evt) {
      const val = this.filterForms(evt.target)
      this.mediaUrl = val.url
    },
    showError (event) {
      this.$logger.error('caption-view', event)
      // this.error = event.message || event.errors.map(err => err.message).join(' ') || event;
    }
  }
}
</script>
<style>
.section-left {
  text-align: left;
  margin-top: 1rem;
}
</style>
